var map = {
	"./large/en1.jpg": 5996,
	"./large/en2.jpg": 9939,
	"./large/en3.jpg": 6279,
	"./large/en4.jpg": 723,
	"./large/en5.jpg": 8236,
	"./large/zh1.jpg": 2744,
	"./large/zh2.jpg": 3647,
	"./large/zh3.jpg": 1768,
	"./large/zh4.jpg": 9882,
	"./large/zh5.jpg": 9246,
	"./small/en1.jpg": 6446,
	"./small/en2.jpg": 5295,
	"./small/en3.jpg": 2264,
	"./small/en4.jpg": 8754,
	"./small/en5.jpg": 6313,
	"./small/zh1.jpg": 9257,
	"./small/zh2.jpg": 586,
	"./small/zh3.jpg": 187,
	"./small/zh4.jpg": 149,
	"./small/zh5.jpg": 8618
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3919;